import {
  ChevronDown,
  ChevronTop,
  CrossIcon,
  PositiveThumb,
} from 'assets/icons';
import Button from 'components/button';
import Divider from 'components/divider/divider';
import EmptyState from 'components/EmptyState/EmptyState';
import useModal from 'components/modal/useModal';
import Pagination from 'components/pagination/pagination';
import StyledInput from 'components/styledInput/StyledInput';
import { dateDiff } from 'helper/helper';
import UseContext from 'hooks/useContext';
import MissionDetailTempWorker from 'pages/pages/mission/missionDetailTempWorker';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ApiDataBase from 'server';

const slideOverAddMissionInvitationAttributionNotification = () => {
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const { toggle } = useModal();
  const [activeTab, setActiveTab] = useState(
    dataCreateMission.user_assigned?._id ? 2 : 1
  );

  const missionId = null;

  const options = [
    { id: 'vivier', label: 'Vivier', modalKey: 'cM_addMissionVivier' },
    {
      id: 'global',
      label: 'Notification Globale',
    },
  ];

  const handleClick = (opt) => {
    if (dataCreateMission.inviteType === opt.id) {
      setDataCreateMission({
        ...dataCreateMission,
        globalNotificationRequested: false,
        inviteType: '',
        vivierSelections: [],
        vivierStatus: [],
      });
    } else if (opt.id === 'global') {
      setDataCreateMission({
        ...dataCreateMission,
        globalNotificationRequested: true,
        inviteType: 'global',
        vivierSelections: [],
        vivierStatus: [],
      });
    } else {
      toggle(opt.modalKey);
    }
  };

  const [searchTempWorker, setSearchTempWorker] = useState('');
  const [searchTempWorkerResult, setSearchTempWorkerResult] = useState([]);
  const [searchTempWorkerResultWaiting, setSearchTempWorkerResultWaiting] =
    useState(false);
  const [searchTempWorkerResultLoadData, setSearchTempWorkerResultLoadData] =
    useState(false);
  const [isTempWorkerResultCompleteOpen, setIsTempWorkerResultCompleteOpen] =
    useState(true);
  const [isTempWorkerResultPartialOpen, setIsTempWorkerResultPartialOpen] =
    useState(true);
  const [
    isTempWorkerResultNotUpdatedOpen,
    setIsTempWorkerResultNotUpdatedOpen,
  ] = useState(true);
  const [
    isTempWorkerResultIncompleteOpen,
    setIsTempWorkerResultIncompleteOpen,
  ] = useState(true);
  const [currentPageTempWorker, setCurrentPageTempWorker] = useState(1);
  const [limitElementTempWorker] = useState(10);
  const [selectedTempWorkerAssignation, setSelectedTempWorkerAssignation] =
    useState(dataCreateMission.user_assigned?._id || null);
  const [countTotalTempWorker, setCountTotalTempWorker] = useState(0);
  const [countPerPageTempWorker, setCountPerPageTempWorker] = useState(0);
  const [totalPagesTempWorker, setTotalPagesTempWorker] = useState(0);

  // Invitation tab (profil selection) state and helpers
  const [tempWorkerRating, setTempWorkerRating] = useState(null);
  const [tempWorkerRatingSearchResult, setTempWorkerRatingSearchResult] =
    useState(null);
  const [
    tempWorkerRatingSearchFinalResult,
    setTempWorkerRatingSearchFinalResult,
  ] = useState(null);
  const [tempWorkerRatingSelected, setTempWorkerRatingSelected] = useState(
    dataCreateMission.users_invite || []
  );
  const [loadingTempWorkerRating, setLoadingTempWorkerRating] = useState(false);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    if (dataCreateMission.company) {
      setLoadingTempWorkerRating(true);
      ApiDataBase.getTempWorkersRatingByMission(
        {
          token,
          idCompany: dataCreateMission.company,
          titleMission: dataCreateMission.title,
          dateStart: dataCreateMission.dateStart,
          dateEnd: dataCreateMission.dateEnd,
        },
        (response) => {
          setTempWorkerRating(response);
          setTempWorkerRatingSearchResult(response);
          setTempWorkerRatingSearchFinalResult(response);
          setLoadingTempWorkerRating(false);
        },
        (err) => {
          toast.error('Une erreur est survenue, veuillez réessayer plus tard.');
        }
      );
    }
  }, [dataCreateMission.company]);

  useEffect(() => {
    if (
      tempWorkerRatingSelected.length === 0 &&
      dataCreateMission.users_invite.length > 0
    ) {
      setTempWorkerRatingSelected(dataCreateMission.users_invite);
    }
  }, [dataCreateMission]);

  useEffect(() => {
    if (
      tempWorkerRatingSelected.length > 0 &&
      dataCreateMission.user_assigned?._id
    ) {
      // Clear assigned profile when inviting someone
      setDataCreateMission((prev) => ({
        ...prev,
        users_invite: tempWorkerRatingSelected,
        user_assigned: {},
      }));
      setSelectedTempWorkerAssignation(null);
    } else {
      // Only update invites
      setDataCreateMission((prev) => ({
        ...prev,
        users_invite: tempWorkerRatingSelected,
      }));
    }
  }, [tempWorkerRatingSelected]);

  useEffect(() => {
    const timer = setTimeout(() => {
      manageTempWorkerRatingSuggestions(search);
    }, 300);
    return () => clearTimeout(timer);
  }, [search]);

  const manageTempWorkerRatingSuggestions = (query) => {
    if (tempWorkerRating?.length > 0) {
      setCurrentPage(1);
      const filtered = tempWorkerRating.filter((tw) =>
        tw.name.toLowerCase().includes(query.toLowerCase())
      );
      setTempWorkerRatingSearchResult(filtered);
    }
  };

  useEffect(() => {
    if (tempWorkerRatingSearchResult) {
      const maxPer = 15;
      const total = tempWorkerRatingSearchResult.length;
      const pages = Math.ceil(total / maxPer);
      const perPage =
        currentPage === pages ? total - (pages - 1) * maxPer : maxPer;
      const start = (currentPage - 1) * perPage;
      const end = start + perPage;
      setCountPerPage(perPage);
      setCountTotal(total);
      setTotalPages(pages);
      setTempWorkerRatingSearchFinalResult(
        tempWorkerRatingSearchResult.slice(start, end)
      );
    }
  }, [tempWorkerRatingSearchResult, currentPage]);

  useEffect(() => {
    if (
      searchTempWorkerResult &&
      Object.keys(searchTempWorkerResult).length > 0
    ) {
      setSelectedTempWorkerAssignation(
        dataCreateMission.user_assigned?._id || null
      );
    }
  }, [searchTempWorkerResult, dataCreateMission.user_assigned]);

  const manageTempWorkerSearch = ({ skipCache }) => {
    setSearchTempWorkerResultWaiting(true);
    setSearchTempWorkerResultLoadData(true);
    ApiDataBase.searchTempWorker(
      {
        token,
        missionId,
        missionData: dataCreateMission,
        search: searchTempWorker,
        page: currentPageTempWorker,
        limit: limitElementTempWorker,
      },
      (data) => {
        setSearchTempWorkerResult(data.users);

        setCountTotalTempWorker(data.count);
        setCountPerPageTempWorker(data.countPerPage);
        setTotalPagesTempWorker(data.countPages);

        setSearchTempWorkerResultWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          setSearchTempWorkerResult([]);
          console.error(err);
        }
      },
      { skipCache }
    );
  };

  useEffect(() => {
    manageTempWorkerSearch({ skipCache: false });
  }, [currentPageTempWorker, searchTempWorker]);

  return (
    <div className="flex flex-col gap-8">
      <div className="text-xl">Inviter un profil</div>
      <div className="flex flex-col gap-2">
        <div className={'flex gap-2'}>
          <div
            onClick={() => setActiveTab(1)}
            className={`flex items-center justify-center py-3 px-4 cursor-pointer text-gray-500 h-9 ${
              activeTab === 1
                ? ' bg-gray-100 text-gray-700 rounded-md '
                : 'hover:bg-gray-100 hover:rounded-md hover:text-gray-700'
            }`}
          >
            <span className="flex items-center gap-1">
              Inviter un profil
              {tempWorkerRatingSelected.length > 0 && (
                <>
                  <span>({tempWorkerRatingSelected.length})</span>
                  <Button
                    size={'ICON'}
                    color={'ICON'}
                    onClick={(e) => {
                      e.stopPropagation();
                      setTempWorkerRatingSelected([]);
                    }}
                  >
                    <CrossIcon wh={20} color={'#374151'} />
                  </Button>
                </>
              )}
            </span>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className={`flex items-center justify-center py-3 px-4 cursor-pointer text-gray-500 h-9 ${
              activeTab === 2
                ? ' bg-gray-100 text-gray-700 rounded-md '
                : 'hover:bg-gray-100 hover:rounded-md hover:text-gray-700'
            }`}
          >
            <span className="flex items-center gap-1">
              Assigner un profil
              {dataCreateMission.user_assigned?._id && (
                <Button
                  size={'ICON'}
                  color={'ICON'}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDataCreateMission({
                      ...dataCreateMission,
                      user_assigned: {},
                    });
                  }}
                >
                  <CrossIcon wh={20} color={'#374151'} />
                </Button>
              )}
            </span>
          </div>
        </div>
        {activeTab === 1 && (
          <div className="flex flex-col gap-3">
            <input
              type="text"
              placeholder="Rechercher un profil"
              className="w-full h-10 py-5 pl-3 pr-8 ft-b border rounded-lg"
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="flex flex-col max-h-[260px] overflow-y-auto">
              {loadingTempWorkerRating ? (
                [1, 2, 3].map((i, index) => (
                  <label
                    key={index}
                    className="flex gap-8 cursor-pointer px-5 py-4 border-b"
                  >
                    <div className="my-auto">
                      <input
                        type="checkbox"
                        className="accent-yellow-400"
                        disabled={true}
                      />
                    </div>
                    <div className="my-auto">
                      <div>
                        <div className="h-3 bg-gray-200 rounded w-10"></div>
                      </div>
                      <div className="text-gray-500 mt-2">
                        <div className="h-2 bg-gray-200 rounded w-80"></div>
                      </div>
                    </div>
                  </label>
                ))
              ) : (
                <>
                  {tempWorkerRatingSearchFinalResult &&
                  tempWorkerRatingSearchFinalResult.length > 0 ? (
                    tempWorkerRatingSearchFinalResult.map(
                      (tempWorker, index) => {
                        let dateText = '';
                        let dateEndMission = {};
                        if (tempWorker.date_end) {
                          dateEndMission = dateDiff(tempWorker.date_end);
                          if (dateEndMission.day >= 0) {
                            if (dateEndMission.day > 0) {
                              dateText = `${dateEndMission.day} ${
                                dateEndMission.day === 1 ||
                                dateEndMission.day === '1'
                                  ? 'jour'
                                  : 'jours'
                              }`;
                            } else if (dateEndMission.hour > 0) {
                              dateText = `${dateEndMission.hour} ${
                                dateEndMission.hour === 1 ||
                                dateEndMission.hour === '1'
                                  ? 'heure'
                                  : 'heures'
                              }`;
                            } else if (dateEndMission.min > 0) {
                              dateText = `${dateEndMission.min} minutes`;
                            } else if (dateEndMission.sec > 0) {
                              dateText = `${dateEndMission.sec} secondes`;
                            }
                          } else {
                            const dateAbs = Object.fromEntries(
                              Object.entries(dateEndMission).map(
                                ([key, value]) => [key, Math.abs(value)]
                              )
                            );
                            if (dateAbs.day > 0) {
                              dateText = `${dateAbs.day} ${
                                dateAbs.day === 1 || dateAbs.day === '1'
                                  ? 'jour'
                                  : 'jours'
                              }`;
                            } else if (dateAbs.hour > 0) {
                              dateText = `${dateAbs.hour} ${
                                dateAbs.hour === 1 || dateAbs.hour === '1'
                                  ? 'heure'
                                  : 'heures'
                              }`;
                            } else if (dateAbs.min > 0) {
                              dateText = `${dateAbs.min} minutes`;
                            } else if (dateAbs.sec > 0) {
                              dateText = `${dateAbs.sec} secondes`;
                            }
                          }
                        }
                        return (
                          <label
                            key={index}
                            className="flex gap-8 justify-between cursor-pointer px-5 py-4 border-b"
                          >
                            <div className="flex gap-8 my-auto">
                              <div className="my-auto">
                                <input
                                  type="checkbox"
                                  className="accent-yellow-400"
                                  onChange={() => {
                                    setTempWorkerRatingSelected((prevData) => {
                                      if (
                                        prevData.find(
                                          (item) =>
                                            item.id_user === tempWorker._id
                                        )
                                      ) {
                                        return prevData.filter(
                                          (item) =>
                                            item.id_user !== tempWorker._id
                                        );
                                      } else {
                                        return [
                                          ...prevData,
                                          {
                                            id_user: tempWorker._id,
                                            name: tempWorker.name,
                                          },
                                        ];
                                      }
                                    });
                                  }}
                                  checked={tempWorkerRatingSelected.find(
                                    (item) => item.id_user === tempWorker._id
                                  )}
                                />
                              </div>
                              <div className="my-auto">
                                <div>{tempWorker.name}</div>
                                {dateText && (
                                  <div className="text-gray-500 text-sm">
                                    {tempWorker.title}{' '}
                                    {dateEndMission.day >= 0
                                      ? 'il y a'
                                      : 'termine dans'}{' '}
                                    {dateText}{' '}
                                    {dataCreateMission &&
                                    dataCreateMission.company !==
                                      tempWorker.id_company
                                      ? `chez ${tempWorker.company}`
                                      : ''}
                                  </div>
                                )}
                              </div>
                            </div>
                            {tempWorker.isRated && (
                              <div className="my-auto">
                                <div className="rounded-full bg-green-50 p-2">
                                  <PositiveThumb wh={20} color={'#10B981'} />
                                </div>
                              </div>
                            )}
                          </label>
                        );
                      }
                    )
                  ) : (
                    <>
                      <EmptyState type={'mission_invitation'} />
                    </>
                  )}
                </>
              )}
            </div>
            {currentPage && totalPages > 1 && setCurrentPage ? (
              <div className="px-8 py-4">
                <Pagination
                  currentPage={currentPage}
                  countPerPage={countPerPage}
                  countTotal={countTotal}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            ) : null}
          </div>
        )}
        {activeTab === 2 && (
          <>
            <StyledInput
              type={'text'}
              value={searchTempWorker}
              onChange={(e) => setSearchTempWorker(e.target.value)}
            />
            {searchTempWorkerResultLoadData ? (
              <>
                {searchTempWorkerResultWaiting ? (
                  <div className="flex flex-col animate-pulse">
                    {[1, 2, 3, 4, 5].map((i, idx) => (
                      <div
                        key={idx}
                        className="w-full flex flex-col gap-5 px-2 py-4 border-b cursor-pointer"
                      >
                        <div className="flex flex-col gap-2">
                          <div className="text-gray-500">
                            <div className="flex flex-col gap-3">
                              <div className="w-full text-sm">
                                <div className="flex flex-col gap-1">
                                  <div className="flex gap-1 items-center w-full flex-1 min-w-0">
                                    <div className="text-base text-gray-900 truncate">
                                      <div className="w-56 h-5 bg-gray-200 rounded" />
                                    </div>
                                  </div>
                                  <div className="w-56 h-5 bg-gray-200 rounded" />
                                  <div className="w-56 h-5 bg-gray-200 rounded" />
                                </div>
                              </div>
                              <div className="flex gap-1">
                                <div className="w-12 h-5 bg-gray-200 rounded" />
                                <div className="w-12 h-5 bg-gray-200 rounded" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {searchTempWorkerResult ? (
                      <>
                        <div className="max-h-[220px] overflow-y-auto w-full my-2 border rounded">
                          <div className="flex flex-col gap-2">
                            {searchTempWorkerResult.complete?.length > 0 ||
                            searchTempWorkerResult.partial?.length > 0 ||
                            searchTempWorkerResult.not_updated?.length > 0 ||
                            searchTempWorkerResult.incomplete?.length > 0 ? (
                              <>
                                {/* DISPONIBILITÉ COMPLÈTE */}
                                {searchTempWorkerResult.complete.length > 0 && (
                                  <div className="flex flex-col">
                                    <Divider />
                                    <div
                                      className="flex justify-between cursor-pointer px-1 py-2"
                                      onClick={() =>
                                        setIsTempWorkerResultCompleteOpen(
                                          !isTempWorkerResultCompleteOpen
                                        )
                                      }
                                    >
                                      <div className="my-auto">
                                        DISPONIBILITÉ COMPLÈTE
                                      </div>
                                      <div className="my-auto">
                                        {isTempWorkerResultCompleteOpen ? (
                                          <ChevronDown
                                            wh={20}
                                            color="#374151"
                                          />
                                        ) : (
                                          <ChevronTop wh={20} color="#374151" />
                                        )}
                                      </div>
                                    </div>
                                    {isTempWorkerResultCompleteOpen &&
                                      searchTempWorkerResult.complete.map(
                                        (tempWorker, index) => (
                                          <div
                                            key={tempWorker._id}
                                            className={`
                                          w-full rounded
                                          ${
                                            selectedTempWorkerAssignation ===
                                            tempWorker._id
                                              ? 'border border-yellow-500 bg-yellow-50'
                                              : 'border-b'
                                          }
                                        `}
                                          >
                                            <MissionDetailTempWorker
                                              index={index}
                                              tempWorker={tempWorker}
                                              selectedTempWorkerAssignation={
                                                selectedTempWorkerAssignation
                                              }
                                              setSelectedTempWorkerAssignation={
                                                setSelectedTempWorkerAssignation
                                              }
                                              missionDateStart={
                                                dataCreateMission.duration
                                                  ?.dateStart
                                              }
                                              missionDateEnd={
                                                dataCreateMission.duration
                                                  ?.dateEnd
                                              }
                                              onClickAssignation={(id) => {
                                                setDataCreateMission({
                                                  ...dataCreateMission,
                                                  inviteType: '',
                                                  vivierSelections: [],
                                                  globalNotificationRequested: false,
                                                  vivierStatus: [],
                                                  user_assigned: {
                                                    _id: tempWorker._id,
                                                    lastname:
                                                      tempWorker.lastname,
                                                    firstname:
                                                      tempWorker.firstname,
                                                  },
                                                  users_invite: [],
                                                });
                                                setTempWorkerRatingSelected([]);
                                                setSelectedTempWorkerAssignation(
                                                  id
                                                );
                                              }}
                                            />
                                          </div>
                                        )
                                      )}
                                  </div>
                                )}
                                {/* DISPONIBILITÉ PARTIELLE */}
                                {searchTempWorkerResult.partial.length > 0 && (
                                  <div className="flex flex-col">
                                    <Divider />
                                    <div
                                      className="flex justify-between cursor-pointer px-1 py-2"
                                      onClick={() =>
                                        setIsTempWorkerResultPartialOpen(
                                          !isTempWorkerResultPartialOpen
                                        )
                                      }
                                    >
                                      <div className="my-auto">
                                        DISPONIBILITÉ PARTIELLE
                                      </div>
                                      <div className="my-auto">
                                        {isTempWorkerResultPartialOpen ? (
                                          <ChevronDown
                                            wh={20}
                                            color="#374151"
                                          />
                                        ) : (
                                          <ChevronTop wh={20} color="#374151" />
                                        )}
                                      </div>
                                    </div>
                                    {isTempWorkerResultPartialOpen &&
                                      searchTempWorkerResult.partial.map(
                                        (tempWorker, index) => (
                                          <div
                                            key={tempWorker._id}
                                            className={`
                                              w-full rounded
                                              ${
                                                selectedTempWorkerAssignation ===
                                                tempWorker._id
                                                  ? 'border border-yellow-500 bg-yellow-50'
                                                  : 'border-b'
                                              }
                                            `}
                                          >
                                            <MissionDetailTempWorker
                                              index={index}
                                              tempWorker={tempWorker}
                                              selectedTempWorkerAssignation={
                                                selectedTempWorkerAssignation
                                              }
                                              setSelectedTempWorkerAssignation={
                                                setSelectedTempWorkerAssignation
                                              }
                                              missionDateStart={
                                                dataCreateMission.duration
                                                  ?.dateStart
                                              }
                                              missionDateEnd={
                                                dataCreateMission.duration
                                                  ?.dateEnd
                                              }
                                              onClickAssignation={(id) => {
                                                setDataCreateMission({
                                                  ...dataCreateMission,
                                                  inviteType: '',
                                                  vivierSelections: [],
                                                  globalNotificationRequested: false,
                                                  vivierStatus: [],
                                                  user_assigned: {
                                                    _id: tempWorker._id,
                                                    lastname:
                                                      tempWorker.lastname,
                                                    firstname:
                                                      tempWorker.firstname,
                                                  },
                                                  users_invite: [],
                                                });
                                                setTempWorkerRatingSelected([]);
                                                setSelectedTempWorkerAssignation(
                                                  id
                                                );
                                              }}
                                            />
                                          </div>
                                        )
                                      )}
                                  </div>
                                )}
                                {/* NON MIS À JOUR */}
                                {searchTempWorkerResult.not_updated.length >
                                  0 && (
                                  <div className="flex flex-col">
                                    <Divider />
                                    <div
                                      className="flex justify-between cursor-pointer px-1 py-2"
                                      onClick={() =>
                                        setIsTempWorkerResultNotUpdatedOpen(
                                          !isTempWorkerResultNotUpdatedOpen
                                        )
                                      }
                                    >
                                      <div className="my-auto">
                                        NON MIS À JOUR
                                      </div>
                                      <div className="my-auto">
                                        {isTempWorkerResultNotUpdatedOpen ? (
                                          <ChevronDown
                                            wh={20}
                                            color="#374151"
                                          />
                                        ) : (
                                          <ChevronTop wh={20} color="#374151" />
                                        )}
                                      </div>
                                    </div>
                                    {isTempWorkerResultNotUpdatedOpen &&
                                      searchTempWorkerResult.not_updated.map(
                                        (tempWorker, index) => (
                                          <div
                                            key={tempWorker._id}
                                            className={`
                                              w-full rounded
                                              ${
                                                selectedTempWorkerAssignation ===
                                                tempWorker._id
                                                  ? 'border border-yellow-500 bg-yellow-50'
                                                  : 'border-b'
                                              }
                                            `}
                                          >
                                            <MissionDetailTempWorker
                                              index={index}
                                              tempWorker={tempWorker}
                                              selectedTempWorkerAssignation={
                                                selectedTempWorkerAssignation
                                              }
                                              setSelectedTempWorkerAssignation={
                                                setSelectedTempWorkerAssignation
                                              }
                                              missionDateStart={
                                                dataCreateMission.duration
                                                  ?.dateStart
                                              }
                                              missionDateEnd={
                                                dataCreateMission.duration
                                                  ?.dateEnd
                                              }
                                              onClickAssignation={(id) => {
                                                setDataCreateMission({
                                                  ...dataCreateMission,
                                                  inviteType: '',
                                                  vivierSelections: [],
                                                  globalNotificationRequested: false,
                                                  vivierStatus: [],
                                                  user_assigned: {
                                                    _id: tempWorker._id,
                                                    lastname:
                                                      tempWorker.lastname,
                                                    firstname:
                                                      tempWorker.firstname,
                                                  },
                                                  users_invite: [],
                                                });
                                                setTempWorkerRatingSelected([]);
                                                setSelectedTempWorkerAssignation(
                                                  id
                                                );
                                              }}
                                            />
                                          </div>
                                        )
                                      )}
                                  </div>
                                )}
                                {/* NON DISPONIBLE */}
                                {searchTempWorkerResult.incomplete.length >
                                  0 && (
                                  <div className="flex flex-col">
                                    <Divider />
                                    <div
                                      className="flex justify-between cursor-pointer px-1 py-2"
                                      onClick={() =>
                                        setIsTempWorkerResultIncompleteOpen(
                                          !isTempWorkerResultIncompleteOpen
                                        )
                                      }
                                    >
                                      <div className="my-auto">
                                        NON DISPONIBLE
                                      </div>
                                      <div className="my-auto">
                                        {isTempWorkerResultIncompleteOpen ? (
                                          <ChevronDown
                                            wh={20}
                                            color="#374151"
                                          />
                                        ) : (
                                          <ChevronTop wh={20} color="#374151" />
                                        )}
                                      </div>
                                    </div>
                                    {isTempWorkerResultIncompleteOpen &&
                                      searchTempWorkerResult.incomplete.map(
                                        (tempWorker, index) => (
                                          <div
                                            key={tempWorker._id}
                                            className={`
                                              w-full rounded
                                              ${
                                                selectedTempWorkerAssignation ===
                                                tempWorker._id
                                                  ? 'border border-yellow-500 bg-yellow-50'
                                                  : 'border-b'
                                              }
                                            `}
                                          >
                                            <MissionDetailTempWorker
                                              index={index}
                                              tempWorker={tempWorker}
                                              selectedTempWorkerAssignation={
                                                selectedTempWorkerAssignation
                                              }
                                              setSelectedTempWorkerAssignation={
                                                setSelectedTempWorkerAssignation
                                              }
                                              missionDateStart={
                                                dataCreateMission.duration
                                                  ?.dateStart
                                              }
                                              missionDateEnd={
                                                dataCreateMission.duration
                                                  ?.dateEnd
                                              }
                                              onClickAssignation={(id) => {
                                                setDataCreateMission({
                                                  ...dataCreateMission,
                                                  inviteType: '',
                                                  vivierSelections: [],
                                                  globalNotificationRequested: false,
                                                  vivierStatus: [],
                                                  user_assigned: {
                                                    _id: tempWorker._id,
                                                    lastname:
                                                      tempWorker.lastname,
                                                    firstname:
                                                      tempWorker.firstname,
                                                  },
                                                  users_invite: [],
                                                });
                                                setTempWorkerRatingSelected([]);
                                                setSelectedTempWorkerAssignation(
                                                  id
                                                );
                                              }}
                                            />
                                          </div>
                                        )
                                      )}
                                  </div>
                                )}
                              </>
                            ) : (
                              <>Pas d'intérimaire trouvé</>
                            )}
                          </div>
                        </div>
                        <div>
                          <Pagination
                            currentPage={currentPageTempWorker}
                            countPerPage={limitElementTempWorker}
                            countTotal={countTotalTempWorker}
                            totalPages={totalPagesTempWorker}
                            setCurrentPage={setCurrentPageTempWorker}
                          />
                        </div>
                      </>
                    ) : (
                      <>Pas d'intérimaire trouvé</>
                    )}
                  </>
                )}
              </>
            ) : (
              <>la</>
            )}
          </>
        )}
      </div>
      <Divider />
      <div className="text-xl">Notifier la mission</div>
      <div className="flex flex-col gap-2">
        {options.map((opt) => {
          const isDisabled = Boolean(dataCreateMission.user_assigned?._id);
          const isSelected = dataCreateMission.inviteType === opt.id;
          const baseClasses = 'w-full border p-6';
          const stateClasses = isDisabled
            ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
            : isSelected
            ? 'bg-yellow-50 border-yellow-500 cursor-pointer'
            : 'bg-gray-50 border-grey-500 cursor-pointer';
          return (
            <div
              key={opt.id}
              className={`${baseClasses} ${stateClasses}`}
              onClick={() => {
                if (!isDisabled) handleClick(opt);
              }}
            >
              {opt.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default slideOverAddMissionInvitationAttributionNotification;
